// The engine applies Max Price to lock-day + adjustment points before
// compensation. Keep that transformation in one place so the table, target
// matching, and expanded calculation all use the same capped price.
export const getMaxPriceBreakdown = (rate) => {
  const prices = rate?.prices || {};
  const lockDayPoint = Number(prices.lockDayPoint) || 0;
  const adjustmentPoint = Number(prices.adjustmentPoint) || 0;
  const loanAmount = Number(rate?.loanAmount) || 0;
  const beforeCapPoints = lockDayPoint + adjustmentPoint;
  const rawCapPoints = rate?.maxPriceCap;
  const capPoints = Number(rawCapPoints) || 0;
  const hasMaxPriceCap = rawCapPoints != null;
  const afterCapPoints = hasMaxPriceCap && beforeCapPoints < capPoints
    ? capPoints
    : beforeCapPoints;

  return {
    hasMaxPriceCap,
    capPoints,
    beforeCapPoints,
    afterCapPoints,
    beforeCapPrice: 100 - beforeCapPoints,
    afterCapPrice: 100 - afterCapPoints,
    beforeCapAmount: beforeCapPoints * loanAmount / 100,
    capAmount: capPoints * loanAmount / 100,
    afterCapAmount: afterCapPoints * loanAmount / 100,
  };
};

// Connected lenders return the final net price/amount from the engine because
// compensation is part of that value. Unconnected lenders have no compensation
// and therefore use the same gross after-cap values as the Price column/detail.
export const getNetPricingBreakdown = (rate) => {
  const pricing = getMaxPriceBreakdown(rate);
  const isConnected = Boolean(rate?.isConnected);
  const points = isConnected ? Number(rate?.points) || 0 : pricing.afterCapPoints;
  const amount = isConnected ? Number(rate?.lender_credit) || 0 : pricing.afterCapAmount;
  return {
    ...pricing,
    points,
    price: 100 - points,
    amount,
  };
};
